import { alpha } from "@mui/material";

const useStyles = (theme, fullScreem) => ({
  stackOption: {
    flexDirection: "row",
    width: "100%",
    p: "5px",
    alignItems: "center",
  },
  textoLimitado: {
    display: "-webkit-box",
    WebkitLineClamp: 2, // Limita o texto a 2 linhas
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  text: {
    fontSize: "0.875rem",
    color: theme.palette.color.text,
  },
  buttonRoter: {
    padding: "10px",
    width: "50%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
    },
  },

  textButtonRoter: { textTransform: "none", fontSize: "0.9rem" },
  buttonBottom: {
    width: "33%",
    textTransform: "none",
  },
  paper: {
    borderRadius: "0px",
    height: "calc(100vh-65px)",
    position: "sticky",
    width: "340px!important",
    backgroundColor: theme.palette.background.sideBar,
  },
  header: {
    display: "flex",
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    gap: 2,
    p: "10px",
  },
  container: {
    flex: 1,
    minHeight: 0,
    overflow: "auto",
    paddingRight: "5px",
    gap: 1.5,
  },
  drawer: {
    position: "absolute",
    clipPath: "none",
    marginTop: "65px",
    flexShrink: 0,
    overflow: "visible",
    "& .MuiDrawer-paper": {
      borderRadius: "7px",
      color: theme.palette.text.primary,
      mr: "10px",
      height: {
        xs: fullScreem ? "calc(100vh - 120px)" : "calc(100vh - 180px)",
        sm: fullScreem ? "calc(100vh - 20px)" : "calc(100vh - 85px)",
      },
      marginTop: {
        xs: fullScreem ? "45px" : "100px",
        sm: fullScreem ? "10px" : "75px",
      },

      width: { xs: "90vw", sm: "380px" },
      padding: "10px 10px",

      overflow: "visible",
      backgroundColor: theme.palette.background.sideBar,
      border: "1px solid " + theme.palette.color.appBarBorder,
      display: "flex",
      gap: 2,
    },
  },
  title: {
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.shadow,
  },
  toggleBtn: {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider} !important`,
    borderRadius: "5px !important",
    textTransform: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    "&.Mui-selected": {
      color: (theme) => theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
      border: theme.palette.primary.main + " solid 1px !important",

      "&:hover": {
        backgroundColor: theme.palette.background.card,
      },
    },
    "&:hover": {
      backgroundColor: theme.palette.background.paperSelectedMaps,
    },
  },
  boxTabs: {
    borderRadius: "5px",
    backgroundColor: theme.palette.background.paperSelectedMaps,
    border: "none",
    "&::before": { display: "none" },
    p: 0.5,
    mt: 0,
    height: "50px",
  },
  tabs: {
    "& button": {
      color: theme.palette.text.disabled,
      textTransform: "none",
      minHeight: "20px",
      height: "100%",
      borderRadius: "5px",
      paddingX: "10px",
    },
    "& .MuiTab-icon": { marginRight: "2px" },
    "& button.Mui-selected": {
      backgroundColor: theme.palette.background.tab,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
      border: "none",
    },
  },
  tab: {
    fontSize: "0.875rem",
    color: theme.palette.color.text,
    "& .MuiTab-icon": { marginRight: "1px" },
  },
  autocomplete: {
    width: "100%",
    backgroundColor: theme.palette.background.paperLinked,
  },
  toggleGroup: {
    display: "flex",
    flexDirection: "row",
    gap: 1,
    width: "100%",
    mb: 1,
  },
});
export default useStyles;
